






































import { Component, Vue, Prop } from "vue-property-decorator";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

interface Resources {
    image: string;
    title: string;
    description: string;
    url: string;
}

@Component({
    components: {
        Swiper,
        SwiperSlide,
    },
})
export default class CompanyResources extends Vue {
    @Prop({
        required: true,
        default: [],
    })
    resources!: Array<Resources>;

    featuredImageFallback = require("@/assets/images/featuredFallback2.png");

    get companyResources() {
        return this.resources.filter((item: any) => item.title);
    }
}
